import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ForgotPasswordService from '../Services/ForgotPasswordService';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tokenValid, setTokenValid] = useState(true); // Assume valid unless backend says otherwise
  const navigate = useNavigate();

  // Optionally, you could add a backend endpoint to validate the token before allowing reset

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const data = await ForgotPasswordService.resetPassword(token, newPassword);
      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.message || 'Something went wrong.');
      }
    } catch (err) {
      setError('Something went wrong.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!token) {
      setTokenValid(false);
    }
    // Optionally, call a backend endpoint to validate token here
  }, [token]);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#B3DFFF', marginTop: "-30px" }}>
      <div className="bg-white p-4 p-md-5 rounded-3 shadow-lg" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-4">
          <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '64px', height: '64px' }}>
            <i className="fas fa-key fa-2x text-primary"></i>
          </div>
          <h2 className="fw-bold">Reset Password</h2>
          <p className="text-muted">Enter your new password below.</p>
        </div>
        {!tokenValid ? (
          <div className="alert alert-danger text-center">Invalid or missing token.</div>
        ) : success ? (
          <div className="alert alert-success text-center">
            Your password has been reset successfully.<br />
            <button className="btn btn-link mt-2" onClick={() => navigate('/signin')}>Back to Sign In</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label className="form-label">New Password</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-lock"></i>
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="input-group-text"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: 'pointer' }}
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">Confirm Password</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-lock"></i>
                </span>
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  className="form-control"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="input-group-text"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{ cursor: 'pointer' }}
                >
                  <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>
            {error && <div className="alert alert-danger text-center">{error}</div>}
            <button type="submit" className="btn btn-dark w-100 py-2" disabled={loading || !newPassword || !confirmPassword}>
              {loading ? <span><i className="fas fa-spinner fa-spin me-2"></i>Resetting...</span> : 'Reset Password'}
            </button>
            <div className="text-center mt-3">
              <button type="button" className="btn btn-link text-decoration-none" onClick={() => navigate('/signin')}>Back to Sign In</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword; 